import { render, staticRenderFns } from "./impresionDxShow.vue?vue&type=template&id=abbaa7b0&"
import script from "./impresionDxShow.vue?vue&type=script&lang=js&"
export * from "./impresionDxShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports